export default {"src":"/_next/static/media/hypotenuse_logo_text_dark.16814fb4.svg","height":28,"width":212};